// Page-level text
export default {
  common: {
    home: 'Home',
    category: 'Category',
    tool: 'Tool',
    toolCountUnit: 'tools',
    noDescription: 'No description'
  },
  home: {
    docTitle: 'IEasyTool - Online Tools',
    metaDescription: 'IEasyTool online tools — a free and practical online toolbox covering text processing, encoding/decoding, diagramming, developer utilities, document conversion, calculators and hundreds more, ready to use instantly.',
    metaKeywords: 'online tools,JSON formatter,Base64 encode,QR code generator,image compress,flowchart,mind map,mortgage calculator,MD5,timestamp converter',
    badge: 'Ready to use · Completely free',
    title: 'Online Tools',
    desc: 'A ready-to-use online toolbox with {count} practical tools for text processing, encoding/decoding, diagramming, developer utilities, document conversion, calculators and more',
    statTools: 'Online Tools',
    statCategories: 'Categories',
    statFree: 'Free to Use',
    sectionCategoryTitle: 'Categories',
    sectionCategorySub: 'Browse tools by category',
    collapse: 'Collapse',
    showAll: 'Show all {count} categories',
    sectionHotTitle: 'Popular Tools',
    sectionHotSub: 'The most popular online tools',
    sectionRecentTitle: 'Recently Updated',
    sectionRecentSub: 'Newly released tools'
  },
  category: {
    defaultDesc: 'Explore all tools in this category',
    countUnit: 'tools',
    empty: 'No tools in this category yet',
    docTitleSuffix: ' - IEasyTool Online Tools'
  },
  search: {
    resultTitle: 'Search results: {keyword}',
    resultCount: '{total} tools found',
    empty: 'No matching tools found',
    emptyHintPrefix: 'Try other keywords, or browse the ',
    emptyHintLink: 'home page',
    placeholder: 'Search tools...'
  },
  favorites: {
    title: 'My Favorites',
    count: '{count} tools',
    emptyTitle: 'No favorites yet',
    emptyDesc: 'Click the star button while browsing a tool to add it here',
    discover: 'Discover Tools'
  },
  detail: {
    useCount: '{count} uses',
    favCount: '{count} favorites',
    fav: 'Favorite',
    faved: 'Favorited',
    usage: 'Usage',
    docTitleSuffix: ' - Online Tool'
  },
  card: {
    fav: 'Favorite',
    unfav: 'Unfavorite'
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'For any questions or partnership inquiries, reach us via the form below and we will reply as soon as possible',
    typeAd: 'Advertising',
    typeTool: 'Tool Issue',
    typeCooperation: 'Partnership',
    typeOther: 'Other',
    phName: 'Your name',
    phEmail: 'Email address',
    phContent: 'Describe your question or partnership inquiry in detail...',
    submit: 'Send Message',
    ruleName: 'Please enter your name',
    ruleEmail: 'Please enter your email',
    ruleEmailInvalid: 'Invalid email format',
    ruleContent: 'Please enter the content',
    submitSuccess: 'Submitted successfully, we will get back to you soon',
    submitFail: 'Submission failed, please try again later'
  },
  terms: {
    body: `<h1>Terms of Service</h1>
<p class="update">Last updated: June 2, 2026</p>
<h2>1. Service Description</h2>
<p>IEasyTool (the "Site") is an online toolbox offering utilities such as JSON formatting, encoding conversion, image processing, and document conversion. All tools are free to use and require no registration.</p>
<h2>2. User Responsibilities</h2>
<p>When using the Site's tools, users must comply with applicable laws and regulations. Using the tools for any illegal or criminal activity is strictly prohibited, including but not limited to:</p>
<ul>
<li>Intruding into others' networks or systems</li>
<li>Distributing malicious code or viruses</li>
<li>Infringing others' intellectual property or privacy</li>
<li>Engaging in fraud, gambling, or other illegal activities</li>
</ul>
<h2>3. Disclaimer</h2>
<p>The tools are provided "as is" without any express or implied warranty. The Site makes no guarantee regarding the accuracy of results or service availability. The Site is not liable for any loss arising from the use of its tools.</p>
<h2>4. Service Changes</h2>
<p>The Site reserves the right to modify or terminate services at any time without prior notice.</p>
<h2>5. Intellectual Property</h2>
<p>The code, design, and content of the Site are the intellectual property of the Site. Copying, mirroring, or commercial use without permission is prohibited.</p>
<h2>6. Contact Us</h2>
<p>For any questions, please contact: y15755141030@163.com</p>`
  },
  privacy: {
    body: `<h1>Privacy Policy</h1>
<p class="update">Last updated: June 2, 2026</p>
<h2>1. Information Collection</h2>
<p>The Site is a static tool site and does not require registration or login. We only collect the following necessary information:</p>
<ul>
<li><strong>Usage logs</strong>: To measure tool usage, we record usage logs (tool ID, access time, anonymous session identifier) that contain no personally identifiable information.</li>
<li><strong>Ad click logs</strong>: If you click an ad on a page, we record the click event (ad ID, page type, time, IP address) for ad performance statistics.</li>
</ul>
<h2>2. Information Use</h2>
<p>The collected information is used only for:</p>
<ul>
<li>Analyzing tool usage to improve service quality</li>
<li>Evaluating ad performance</li>
</ul>
<p>We will not use the information for any other purpose, nor share it with third parties.</p>
<h2>3. Cookies and Local Storage</h2>
<p>The Site uses browser localStorage to store your favorites list. This data is kept only on your local device and is not uploaded to the server. You can clear it in your browser settings.</p>
<h2>4. Third-Party Services</h2>
<p>The Site integrates the following third-party services:</p>
<ul>
<li><strong>IP location lookup</strong>: Calls the ipapi.co or ip-api.com API to look up IP location; the request sends your input to a third-party server.</li>
<li><strong>DNS lookup</strong>: Calls the Google DNS-over-HTTPS API; the request sends the domain to Google servers.</li>
</ul>
<p>Please refer to the respective third parties' privacy policies for more information.</p>
<h2>5. Information Security</h2>
<p>The Site does not store any files uploaded by users (document conversion, image processing, etc. are all performed locally in the browser). We take reasonable measures to secure server logs but cannot guarantee absolute security.</p>
<h2>6. Contact Us</h2>
<p>For privacy-related questions, please contact: y15755141030@163.com</p>`
  }
}
